import { PlaceResource, placeResource } from '@witkac/kartamiejska-resources';
import { Place } from '@witkac/kartamiejska-shared';

import { EntityModule } from '../entity.module';

/**
 * Moduł obiektów partnera
 *
 * @export
 * @class PlacesModule
 * @extends {EntityModule<Place,PlaceResource>}
 */
export class PlacesModule extends EntityModule<Place, PlaceResource> {
  constructor() {
    super(placeResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje obiekt
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        data.place.id = await this.resource.add(data);
        context.commit('add', data.place);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje obiekt
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        data.place.id = await this.resource.update(data.id, data);
        context.commit('update', data.place);
        context.commit('setEntity', data.place);
      }
    };
  }
}

export default new PlacesModule();
